import PropTypes from "prop-types";
import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Alert from "@material-ui/lab/Alert";
import { useDispatch, useSelector } from "react-redux";
import { setSocialSecurityFunc } from "../utils/fetcher";
import { goToBeginning } from "../utils/scenario-manager";
import { translator } from "../utils/i18n";
import InputMask from "react-input-mask";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Close } from "@material-ui/icons";

export default function SocialSecurityDialog(props) {
  const dispatch = useDispatch();
  const NbrSocialSecurity = useSelector(state => state.socialSecurity);
  const [securityId, setSecurityId] = useState(
    props.currentPatientInfo.num_securite_sociale_user
  );
  const [address, setAddress] = useState(props.currentPatientInfo.adresse_user);
  const [codePostal, setCodePostal] = useState(
    props.currentPatientInfo.code_postal_user
  );
  const [ville, setVille] = useState(props.currentPatientInfo.ville_user);
  const [medecinTraitant, setMedecinTraitant] = useState(
    props.currentPatientInfo.medecin_traitant_user
  );
  const [alertSecurityId, setAlertSecurityId] = useState(false);
  const [alertAddr, setAlertAddr] = useState(false);
  const [alertCP, setAlertCP] = useState(false);
  const [alertVille, setAlertVille] = useState(false);
  const [alertMT, setAlertMT] = useState(false);

  const MASK_SECID = "9 99 99 99 999 999 99";
  const MASK_CP = "99 999";

  const handleSave = e => {
    e.preventDefault();

    if (checkParameters(props.infoNewForm)) {
      dispatch(
        setSocialSecurityFunc(
          securityId.replace(/\s/g, ""),
          props.patientId,
          address,
          codePostal,
          ville,
          medecinTraitant
        )
      );
    }
  };

  const checkParameters = infoNewForm => {
    var result = true;

    if (infoNewForm.b_activ_adresse && !checkAddr()) {
      result = false;
    }

    if (infoNewForm.b_activ_medecin_traitant && !checkMT()) {
      result = false;
    }

    if (props.isRequiredSocialSecurity && !checkSecId()) {
      result = false;
    }

    return result;
  };

  const checkParam = (param, setAlertParam, alertParam, mask) => {
    var result = true;

    if (
      !param ||
      param === "" ||
      (mask &&
        param.replace(/\s/g, "").length !== mask.replace(/\s/g, "").length)
    ) {
      setAlertParam(true);
      result = false;
    } else if (alertParam) {
      setAlertParam(false);
    }

    return result;
  };

  const checkMT = () => {
    var result = true;
    result = result && checkParam(medecinTraitant, setAlertMT, alertMT);
    return result;
  };

  const checkAddr = () => {
    var result = true;

    result = checkParam(address, setAlertAddr, alertAddr) && result;
    result = checkParam(codePostal, setAlertCP, alertCP, MASK_CP) && result;
    result = checkParam(ville, setAlertVille, alertVille) && result;

    return result;
  };

  const checkSecId = () => {
    var result = true;

    result = checkParam(
      securityId,
      setAlertSecurityId,
      alertSecurityId,
      MASK_SECID
    );

    return result;
  };

  const goToHome = () => {
    dispatch(goToBeginning());
  };

  const goToPrevious = () => {
    props.closeDialog();
  };

  return (
    <form>
      <Dialog
        fullWidth={true}
        PaperProps={{
          style: { width: "419px", paddingLeft: "44px", paddingRight: "44px" }
        }}
        open={NbrSocialSecurity === 2 || NbrSocialSecurity === 0}
      >
        <DialogTitle
          id="simple-dialog-title"
          className="title_dialog_header_social_security"
        >
          <div
            dangerouslySetInnerHTML={{
              __html: translator()._("W_MSG_HEADER_SOCIAL_SECURITY_DIALOG")
            }}
          />
          <Button
            type="submit"
            onClick={goToPrevious}
            color="primary"
            className="close-button"
          >
            <Close />
          </Button>
        </DialogTitle>
        {props.isRequiredSocialSecurity && (
          <DialogContent className="no-padding-left no-padding-right no-overflow">
            <DialogContentText className="mat_dialog_text">
              {translator()._("W_LABEL_SECURITE_SOCIALE")}
              {NbrSocialSecurity === 2 && (
                <Alert severity="error">
                  {translator()._("W_MESSAGE_NON_VALID_NUM_SECURITE_SOCIALE")}
                </Alert>
              )}
            </DialogContentText>
            <InputMask
              className="input-custom"
              mask={MASK_SECID}
              maskChar={null}
              value={securityId}
              onChange={e => setSecurityId(e.target.value)}
            />
            {alertSecurityId && (
              <Alert severity="error">
                {translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")}
              </Alert>
            )}
          </DialogContent>
        )}
        {props.infoNewForm.b_activ_adresse && (
          <div>
            <DialogContent className="mat_dialog_content no-padding-left no-padding-right no-overflow">
              <DialogContentText className="mat_dialog_text">
                {translator()._("W_MON_ADRESS")}
              </DialogContentText>
              <input
                type="text"
                name="address"
                className="input-custom"
                value={address}
                onChange={e => setAddress(e.target.value)}
              />
              {alertAddr && (
                <Alert severity="error">
                  {translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")}
                </Alert>
              )}
            </DialogContent>
            <DialogContent className="mat_dialog_content no-padding-left no-padding-right no-overflow">
              <div className="line-form">
                <div>
                  <DialogContentText className="mat_dialog_text">
                    {translator()._("W_STEP4_FORMULAIRE_CODE_POSTAL")}
                  </DialogContentText>
                  <InputMask
                    className="input-custom"
                    mask={MASK_CP}
                    maskChar={null}
                    value={codePostal}
                    onChange={e => setCodePostal(e.target.value)}
                  />
                  {alertCP && (
                    <Alert severity="error">
                      {translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")}
                    </Alert>
                  )}
                </div>
                <div>
                  <DialogContentText className="mat_dialog_text">
                    {translator()._("W_STEP4_FORMULAIRE_VILLE")}
                  </DialogContentText>
                  <input
                    name="ville"
                    className="input-custom"
                    value={ville}
                    onChange={e => setVille(e.target.value)}
                  />
                  {alertVille && (
                    <Alert severity="error">
                      {translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")}
                    </Alert>
                  )}
                </div>
              </div>
            </DialogContent>
          </div>
        )}
        {props.infoNewForm.b_activ_medecin_traitant && (
          <DialogContent className="mat_dialog_content no-padding-left no-padding-right no-overflow">
            <DialogContentText className="mat_dialog_text">
              {translator()._("W_RELATION_MEDECIN_TRAITANT")}
            </DialogContentText>
            <input
              name="medecinTraitant"
              className="input-custom"
              value={medecinTraitant}
              onChange={e => setMedecinTraitant(e.target.value)}
            />
            {alertMT && (
              <Alert severity="error">
                {translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")}
              </Alert>
            )}
          </DialogContent>
        )}
        <DialogActions>
          <Button
            type="submit"
            onClick={goToHome}
            color="primary"
            className="btn-mat_dialog_content_annule"
          >
            {translator()._("W_ANNULER_RDV")}
          </Button>
          <Button
            type="submit"
            onClick={handleSave}
            color="primary"
            className="btn-mat_dialog_content_valide"
          >
            {translator()._("W_VALIDER")}
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  );
}

SocialSecurityDialog.propTypes = {
  closeDialog: PropTypes.func,
  currentPatientInfo: PropTypes.shape({
    adresse_user: PropTypes.string,
    code_postal_user: PropTypes.string,
    medecin_traitant_user: PropTypes.string,
    num_securite_sociale_user: PropTypes.string,
    ville_user: PropTypes.string
  }),
  infoNewForm: PropTypes.shape({
    b_activ_adresse: PropTypes.bool,
    b_activ_medecin_traitant: PropTypes.bool
  }),
  isRequiredSocialSecurity: PropTypes.bool,
  patientId: PropTypes.any
};
